import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { NgxSmartPlayerModule } from '@vexprotech/ngx-smart-player';

import { AppComponent } from './app.component';


@NgModule({
  imports: [
    BrowserModule,
    CommonModule,
    HttpClientModule,
    NgxSmartPlayerModule
  ],
  providers: [

  ],
  declarations: [
    AppComponent
  ],
  entryComponents: [],
  bootstrap: [AppComponent]
})
export class AppModule {
}

